<template>
  <b-modal
    id="modal-payroll-history-cancel"
    ref="payrollHistoryCancelModal"
    title="Justificativa"
    hide-footer
    centered
  >
    <div v-if="payrollHistory">
      <b-alert
        show
        variant="danger"
        class="p-1"
      >
        O lançamento de folha será removido da competência {{ formatCompetence(payrollHistory.competence) }}.
      </b-alert>
      <div class="mb-1">
        <div>{{ payrollHistory.workplace_name }}</div>
        <div class="font-small-2 text-muted">
          {{ payrollHistory.institution_name }}
        </div>
      </div>
    </div>

    <b-form-group
      label="Motivo"
      label-for="payroll-history-motive"
    >
      <b-form-textarea
        id="payroll-history-motive"
        v-model="motive"
        rows="4"
        placeholder="Descreva o motivo..."
      />
      <small
        v-if="error"
        class="text-danger"
      >{{ error }}</small>
    </b-form-group>

    <div class="text-right">
      <b-button
        variant="primary"
        :disabled="loading"
        @click="submit"
      >
        Remover
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, VBModal, BAlert, BButton, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import reportStoreModule from '@/views/report/reportStoreModule'
import { formatCompetence } from '../useWorkplacePayrollHistoryList'

export default {
  components: {
    BModal,
    BAlert,
    BButton,
    BFormGroup,
    BFormTextarea,
  },
  directives: {
    'b-modal': VBModal,
  },
  methods: { formatCompetence },
  setup(_, { emit }) {
    const toast = useToast()
    const STORE_MODULE_NAME = 'app-reports'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, reportStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const payrollHistoryCancelModal = ref(null)
    const payrollHistory = ref(null)
    const motive = ref('')
    const error = ref('')
    const loading = ref(false)

    function show(item) {
      payrollHistory.value = item
      motive.value = ''
      error.value = ''
      payrollHistoryCancelModal.value.show()
    }

    function submit() {
      if (!motive.value.trim()) {
        error.value = 'Informe o motivo'
        return
      }

      error.value = ''
      loading.value = true
      store
        .dispatch(`${STORE_MODULE_NAME}/cancelWorkplacePayrollHistory`, {
          payroll_history_id: payrollHistory.value.id,
          motive: motive.value,
        })
        .then(() => {
          payrollHistoryCancelModal.value.hide()
          emit('refetch-data')
          toast({
            component: ToastificationContent,
            props: {
              title: 'Removido',
              icon: 'TrashIcon',
              variant: 'success',
            },
          })
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao remover',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          loading.value = false
        })
    }

    return {
      payrollHistoryCancelModal,
      payrollHistory,
      motive,
      error,
      loading,
      show,
      submit,
    }
  },
}
</script>
